import { Config } from '@atlassian/ufo-config';

import { PERFORMANCE_MARK_SSR_HTML } from '../../ssr/services/metrics/constants';

import { getMark } from './utils/getMark';

const FIRST_PAINT_MARK = 'first-paint';

const ssrTimings = () => {
  const ssrTime = getMark(PERFORMANCE_MARK_SSR_HTML);
  if (!ssrTime) {
    return [];
  }
  return [{ label: 'ssr', data: { startTime: 0, duration: ssrTime } }];
};

export const devConfig: Config = {
  enabled: true,
  doNotAbortActivePressInteraction: [],
  doNotAbortActivePressInteractionOnTransition: [],
  awaitBM3TTI: [],
  ufoNameOverrides: {},
  autoGeneratedRate: 1000,
  namePrefix: 'ufo-',
  segmentPrefix: 'ufo-',
  rates: {},
  rules: [],
  killswitch: [],
  typingMethod: 'timeout',
  capability: {
    feature_flag_access: 0,
    react_profiler: 1,
  },
  kind: {
    page_load: 1,
    transition: 1,
    hover: 0,
    legacy: 0,
    press: 0,
    typing: 0,
  },
  // disable collection of resource timings for 'fetch' requests, as they
  // currently contain UGC, e.g. workspace/repository/branch names
  // TODO: remove `allowedResource` config once `sanitiseEndpoints` function is provided
  allowedResources: ['script', 'link'],
  removePageSegmentsUFOPrefixes: false,
  removeInteractionsUFOPrefixes: true,
  enableTTVC: false,
  product: 'bitbucket',
  region: 'unknown',
  ssr: {
    getSSRTimings: () => ssrTimings(),
    getSSRDoneTime: () => getMark(FIRST_PAINT_MARK),
  },
  enableCompleteUsingDoubleRAF: true,
};

export const prodConfig: Config = {
  ...devConfig,
  rates: {
    view_page: 1000,
  },
};
